import {
  HomeIcon,
  SettingsIcon,
  BlogIcon,
  FolderIcon,
  MenuHorizontalIcon,
  NotificationIcon,
  DeliveryFilledIcon,
  ProductIcon,
  ChartVerticalFilledIcon,
  PersonIcon,
  IncomingIcon,
  PackageIcon,
  MoneyIcon,
  AtmWithdrawalIcon,
  StoreManagedIcon,
  PersonalizedTextIcon,
  LockFilledIcon,
  PhoneIcon,
  MobileIcon,
  InfoIcon,
  LocationIcon,
  LocationFilledIcon,
  LogoYoutubeIcon,
  AppsFilledIcon,
  ExchangeIcon,
  FinanceIcon,
  BillIcon,
} from '@shopify/polaris-icons';
import { Navigation, Text, BlockStack } from '@shopify/polaris';
import { useLocation } from 'react-router-dom';
import { default as packageInformation } from '../../package.json';
import helpers from 'helpers/index';
import Capacity from 'components/Capacity';
import { useAuth } from 'context/AuthContext';
import __helpers from 'helpers/index';

const generalMenu: any[] = [
  {
    url: '/',
    label: 'Trang chủ',
    icon: HomeIcon,
    exactMatch: true,
    permissions: [], // Quyền cần để truy cập mục này
  },
  {
    url: '/ticket_managers',
    label: 'Điều chuyến',
    icon: StoreManagedIcon,
    permissions: ['manage_trip_manifest'], // Quyền cần để truy cập mục này
  },

  {
    url: '/charge_transaction',
    label: 'Quản lý phiên sạc',
    icon: ExchangeIcon,
    permissions: ['manage_trip_manifest'], // Quyền cần để truy cập mục này
  },
  {
    url: '/vehicle_tracking',
    label: 'Bản đồ xe',
    icon: LocationIcon,
    permissions: ['manage_vehicle'], // Quyền cần để truy cập mục này
  },
];

const tools = [
  {
    url: '/dispatch',
    label: 'Bản đồ điều phối',
    icon: LocationIcon,
    permissions: ['manage_trip_manifest'], // Quyền cần để truy cập mục này
  },
  {
    url: '/vehicle',
    label: 'Phương tiện',
    icon: DeliveryFilledIcon,
    permissions: ['manage_vehicle'], // Quyền cần để truy cập mục này
  },

  {
    url: '/seating',
    label: 'Số ghế & loại hình',
    icon: AtmWithdrawalIcon,
    permissions: ['manage_seating'], // Quyền cần để truy cập mục này
  },
  {
    url: '/journey',
    label: 'Hành trình & giờ chạy',
    icon: StoreManagedIcon,
    permissions: ['manage_journey'], // Quyền cần để truy cập mục này
  },
  {
    url: '/address_suggestion',
    label: 'Điểm đón',
    icon: LocationFilledIcon,
    permissions: ['manage_address_suggestion'], // Quyền cần để truy cập mục này
  },
  {
    url: '/orders',
    label: 'Đơn hàng',
    icon: ProductIcon,
    permissions: ['manage_orders'], // Quyền cần để truy cập mục này
  },
  {
    url: '/trip_manifest',
    label: 'Chuyến đi',
    icon: BlogIcon,
    permissions: ['manage_trip_manifest'], // Quyền cần để truy cập mục này
  },
];

const saleMenus = [
  {
    url: '/customer',
    label: 'Khách hàng',
    icon: PersonIcon,
    permissions: ['manage_customers', 'view_customers', 'edit_customers'], // Quyền cần để truy cập mục này
  },
  {
    url: '/phonelog',
    label: 'Cuộc gọi',
    icon: PhoneIcon,
    permissions: ['manage_customers', 'manage_phonelogs'], // Quyền cần để truy cập mục này
  },
];

let supporterMenus: any[] = [
  {
    url: '/contactform',
    label: 'Contact Form',
    icon: PersonalizedTextIcon,
    permissions: ['manage_contact_forms'], // Quyền cần để truy cập mục này
  },
  {
    url: '/transactions',
    label: 'Giao dịch',
    icon: MoneyIcon,
    permissions: ['manage_orders'], // Quyền cần để truy cập mục này
  },

  {
    url: '/transactions_callback',
    label: 'Giao dịch callback',
    icon: MoneyIcon,
    permissions: ['manage_orders'], // Quyền cần để truy cập mục này
  },
  {
    url: '/invoices',
    label: 'Hóa đơn',
    icon: BillIcon,
    permissions: ['manage_invoice'], // Quyền cần để truy cập mục này
  },
  {
    url: '/charge_station',
    label: 'Trạm sạc',
    icon: ExchangeIcon,
    permissions: ['manage_contact_forms'], // Quyền cần để truy cập mục này
    subNavigationItems: [
      {
        url: '/charge_station',
        label: 'Trạm sạc',
        permissions: ['manage_contact_forms'], // Quyền cần để truy cập mục này
      },
      {
        url: '/charge_transaction',
        label: 'Phiên sạc',
        permissions: ['manage_contact_forms'], // Quyền cần để truy cập mục con này
      },
      {
        url: '/vehicle_management',
        label: 'Xe',
        permissions: ['manage_contact_forms'], // Quyền cần để truy cập mục con này
      },
    ],
  },
];

const advanceUserItems = [
  {
    url: '/notification',
    label: 'Thông báo',
    icon: NotificationIcon,
    permissions: ['manage_notifications'], // Quyền cần để truy cập mục này
  },
  {
    url: '/posts',
    label: 'Bài đăng và trang',
    icon: BlogIcon,
    permissions: ['manage_posts', 'edit_posts'], // Quyền cần để truy cập mục này
    subNavigationItems: [
      {
        url: '/pages',
        label: 'Danh sách trang',
        permissions: ['manage_posts', 'edit_posts'], // Quyền cần để truy cập mục này
      },
      {
        url: '/posts',
        label: 'Danh sách bài đăng',
        permissions: ['manage_posts', 'edit_posts'], // Quyền cần để truy cập mục này
      },
      {
        url: '/posts/category',
        label: 'Chuyên mục',
        permissions: ['manage_post_categories'], // Quyền cần để truy cập mục con này
      },
    ],
  },
  {
    url: '/media',
    label: 'Media',
    icon: FolderIcon,
    permissions: ['manage_media'], // Quyền cần để truy cập mục này
  },
  {
    url: '/promotion',
    label: 'Promotion',
    icon: LogoYoutubeIcon,
    permissions: ['manage_promotion'], // Quyền cần để truy cập mục này
  },
];

/**
 * For admin
 */
let adminMenuItems = [
  {
    url: '/analytics',
    label: 'Báo cáo',
    icon: ChartVerticalFilledIcon,
    subNavigationItems: [
      { url: '/analytics', icon: MenuHorizontalIcon, label: 'Tổng quan' },
      { url: '/analytics/employees', icon: MenuHorizontalIcon, label: 'Nhân viên' },
      { url: '/analytics/drivers', icon: MenuHorizontalIcon, label: 'Lái xe' },
    ],
  },

  { url: '/driver_settlement', label: 'Phiếu quyết toán', icon: FinanceIcon },

  { url: '/incoming_webhook', label: 'Incoming Webhook', icon: IncomingIcon },

  { url: '/outgoing_webhook', label: 'Outgoing Webhook', icon: PackageIcon },
  {
    url: '/settings/',
    label: 'Cài đặt chung',
    icon: SettingsIcon,
    subNavigationItems: [
      { url: '/settings', icon: MenuHorizontalIcon, label: 'System' },
      { url: '/account_setting', icon: MenuHorizontalIcon, label: 'Tài khoản' },
      { url: '/backup', icon: MenuHorizontalIcon, label: 'Back up' },
      { url: '/pbx', icon: MenuHorizontalIcon, label: 'Tổng đài' },
      { url: '/embed', icon: MenuHorizontalIcon, label: 'Mã nhúng & kết nối' },
      { url: '/media_setting', icon: MenuHorizontalIcon, label: 'Media' },
      { url: '/keymap', icon: MenuHorizontalIcon, label: 'Keymap' },
      { url: '/server_info', icon: MenuHorizontalIcon, label: 'Server info' },
    ],
  },

  { url: '/security/', label: 'Bảo mật', icon: LockFilledIcon },
  {
    url: '/users/',
    label: 'Người dùng',
    icon: PersonIcon,
  },
];

/**
 * START ...
 * @returns
 */
export default function Sidebar() {
  const location = useLocation();
  const version = process.env.REACT_APP_VERSION;
  const polarisVersion = packageInformation['dependencies']['@shopify/polaris'] || '';
  const { user: current_user_data } = useAuth();
  const { capacities, user_role } = current_user_data;

  /** Kiểm tra nếu người dùng hiện tại có quyền */
  const isAllowed = (current_user_can: string): boolean => {
    if (current_user_can === '') return true; // khi không yêu cầu quyền gì ...
    switch (user_role) {
      case 'super_admin':
        return true;
      case 'admin':
        return true;

      default:
        if (user_role === current_user_can) {
          return true;
        } else {
          if (__helpers.isObject(capacities))
            for (let key in capacities) {
              let value = capacities[key];
              if (Array.isArray(value) && value.includes(current_user_can)) {
                return true;
              }
            }
        }
        break;
    }
  };

  /**
   * capacities có dữ liệu dạng
   {
    tên nhóm quyền : [các quyền]
   },...
   */
  const filterMenusByPermission = (menus: any[]) => {
    return menus
      .map((menu) => {
        const hasPermission = helpers.isEmpty(menu.permissions) ? true : menu.permissions.some((permission: any) => isAllowed(permission));
        if (!hasPermission) return null;

        // Lọc subNavigationItems nếu có
        const subNavigationItems = menu.subNavigationItems?.filter((subMenu: any) =>
          helpers.isEmpty(subMenu.permissions) ? true : subMenu.permissions.some((permission: any) => isAllowed(permission))
        );

        return {
          ...menu,
          subNavigationItems, // Gán lại subNavigationItems sau khi lọc
        };
      })
      .filter(Boolean); // Loại bỏ các phần tử null
  };

  // Sử dụng hàm
  const _check_permission_generalMenu = filterMenusByPermission(generalMenu);
  const _check_permission_saleMenus = filterMenusByPermission(saleMenus);
  const _check_permission_toolsMenus = filterMenusByPermission(tools);
  const _check_permission_supporterMenus = filterMenusByPermission(supporterMenus);
  const _check_permission_advanceUserItems = filterMenusByPermission(advanceUserItems);

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={_check_permission_generalMenu} />
      {!helpers.isEmpty(_check_permission_toolsMenus) && <Navigation.Section title="Quản trị" separator items={_check_permission_toolsMenus} />}
      {!helpers.isEmpty(_check_permission_saleMenus) && <Navigation.Section title="Dành cho Sale" separator items={_check_permission_saleMenus} />}
      {!helpers.isEmpty(_check_permission_supporterMenus) && (
        <Navigation.Section title="Dành cho Supporter" separator items={_check_permission_supporterMenus} />
      )}

      {!helpers.isEmpty(_check_permission_advanceUserItems) && (
        <Navigation.Section title="Nâng cao" separator items={_check_permission_advanceUserItems} />
      )}

      <Capacity current_user_can="admin">
        <Navigation.Section title="Quản trị CRM" separator items={adminMenuItems} />
      </Capacity>

      <Navigation.Section fill items={[]} />

      <BlockStack align="center" inlineAlign="center" gap={'200'}>
        <Text as="p" variant="bodyXs" tone="subdued">
          NBEE CRM &copy;2021, version {version}
          <br />
          build: {packageInformation.build_version}
          <br />
          {helpers.isDev() && `Polaris Framework ver ${polarisVersion}`}
        </Text>
        <div style={{ marginBottom: 5, marginTop: 5 }}></div>
      </BlockStack>
    </Navigation>
  );
}

